let booking_details: any;
let bundle_bg_url: any;

export const getEventBookingDetails = () => {
  return booking_details;
};

export const setEventBookingDetails = (details: any) => {
  booking_details = details;
};

export const getBundleBgUrl = () => {
  return bundle_bg_url;
};

export const setBundleBgUrl = (url: any) => {
  bundle_bg_url = url;
};

export const isBookingAllowed = (event: any) => {
  if (event) {
    const currentDate = new Date();
    const eventEndDate = new Date(
      `${event.data.booking_end_time[0]}/${event.data.booking_end_time[1]}/${event.data.booking_end_time[2]} ${event.data.booking_end_time[3]}:${event.data.booking_end_time[4]}`
    );
    return eventEndDate > currentDate;
  }
  return false;
};

export const isSlotBookingAllowed = (
  slot: any,
  checkStartTime: boolean = false
) => {
  if (slot) {
    const currentDate = new Date();
    const eventEndDate = checkStartTime
      ? new Date(
        `${slot.start_time[0]}/${slot.start_time[1]}/${slot.start_time[2]} ${slot.start_time[3]}:${slot.start_time[4]}`
      )
      : new Date(
        `${slot.end_time[0]}/${slot.end_time[1]}/${slot.end_time[2]} ${slot.end_time[3]}:${slot.end_time[4]}`
      );
    if (checkStartTime) {
      eventEndDate.setMinutes(eventEndDate.getMinutes() + 45);
    }
    return eventEndDate > currentDate;
  }
  return false;
};

export const checkDates = (dateOne: any, bufferMinutes?: number) => {
  const currentDate = new Date();
  const endDate = new Date(
    `${dateOne[0]}/${dateOne[1]}/${dateOne[2]} ${dateOne[3]}:${dateOne[4]}`
  );
  if (bufferMinutes) endDate.setMinutes(endDate.getMinutes() - bufferMinutes);

  return endDate > currentDate;
};

export const capitalizeFirstLetter = (str: string): string => {
  if (str) return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  else return str;
};

export const formatOfferDate = (
  date: string | undefined,
  time: string | undefined
) => {
  const inputDate = new Date(date + `, ` + time);
  inputDate.setFullYear(new Date().getFullYear());

  const formattedDate = [
    inputDate
      .toLocaleDateString("en-UK", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-"),
    inputDate.toLocaleTimeString("en-UK", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }),
  ].join(" ");
  return formattedDate;
};

export const formateDate = (date: Date) => {
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
};

export const formateTime = (date: Date) => {
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
};


export const vibrate = () => {
  if (!window) {
    return;
  }

  if (!window.navigator) {
    return;
  }

  if (!window.navigator.vibrate) {
    return;
  }

  window.navigator.vibrate(100);
}

export const personVsPass: { [key: string]: string } = {
  Stag: "Regular Pass",
  Ladies: "VIP",
  Couple: "VVIP",
};

export const roundToNearest30 = (date: Date) => {
  const minutes = date.getMinutes();
  const remainder = minutes % 30;

  // If the remainder is more than 15, round up, otherwise round down
  if (remainder > 15) {
    // Round up to the next 30-minute interval
    date.setMinutes(minutes + (30 - remainder));
  } else {
    // Round down to the previous 30-minute interval
    date.setMinutes(minutes - remainder);
  }

  // Set seconds and milliseconds to 0 for exact 30-min intervals
  date.setSeconds(0);
  date.setMilliseconds(0);

  return date;
};

export const DiscountOffersbgLinearGradient = (category: string) => {
  switch (category) {
    case "TABLE_DISCOUNT":
      return "linear-gradient(180deg, #252525 0%, #1A2038 100%)";
    case "BILL_DISCOUNT":
      return "linear-gradient(180deg, #252525 0%, #331A38 100%)";
    case "COMBOS":
      return "linear-gradient(180deg, #252525 0%, #1A382A 100%)";
    default:
      return "linear-gradient(180deg, #252525 0%, #38371A 100%)";
  }
};

export const convertToAmPm = (timeRange: string) => {
  const [start, end] = timeRange.split(" - ").map((time) => {
    const [hours, minutes] = time.split(":").map(Number);
    const suffix = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12;
    const formattedMinutes = minutes === 0 ? "" : `:${minutes.toString().padStart(2, "0")}`;
    return `${adjustedHours}${formattedMinutes}${suffix}`;
  });
  return `${start} - ${end}`;
};

export const setDiscountImageUrl = (category: string) => {
  switch (category) {
    case "BILL_DISCOUNT":
      return "/images/bill.png";
    case "TABLE_DISCOUNT":
      return "/images/chair_table.png";
    case "COMBOS":
      return "/images/combo.png";
    default:
      return "/images/food-drink.png";
  }
};

export const isLightColor = (color: string) => {

  if (!color) return false;
  const hexToRgb = (hex: string) => {
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }
    const bigint = parseInt(hex, 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  };
  const [r, g, b] = hexToRgb(color);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5;
};